import { createSlice } from '@reduxjs/toolkit';

import { API_URL_KEY, APP_URL_KEY, WORKSPACE_DOMAIN_KEY } from '../constants';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface TenantConfigState {
	client_id: string;
	redirect_url: string;
	api_url: string;
	app_url: string;
	workspace_domain: string;
}

const initialState: TenantConfigState = {
	client_id: '',
	redirect_url: '',
	api_url: localStorage.getItem(API_URL_KEY) || '',
	app_url: '',
	workspace_domain: '',
};

export const tenantConfigSlice = createSlice({
	name: 'tenantConfig',
	initialState,
	reducers: {
		updateTenantConfig: (state, action: PayloadAction<TenantConfigState>) => {
			const { client_id, api_url, app_url, redirect_url, workspace_domain } =
				action.payload;
			state.client_id = client_id;
			state.redirect_url = redirect_url;
			state.api_url = api_url;
			state.app_url = app_url;
			state.workspace_domain = workspace_domain;
			localStorage.setItem(API_URL_KEY, state.api_url);
			localStorage.setItem(APP_URL_KEY, state.app_url);
			localStorage.setItem(WORKSPACE_DOMAIN_KEY, state.workspace_domain);
		},
	},
});

export const { updateTenantConfig } = tenantConfigSlice.actions;

export default tenantConfigSlice.reducer;
